import React from 'react'
import { Card } from 'react-bootstrap'
import ProductInfo from '../Product/ProductInfo'

export const ItemInfoComponent = ({ entity }) => {
  return (
    <Card>
      <Card.Img variant="top" src={entity?.coverImage} />
      <Card.Body>
        <ProductInfo {...entity} />
      </Card.Body>
    </Card>
  )
}
